import React, {ChangeEvent, KeyboardEvent} from "react";
import {WerfenFormFieldColor, WerfenFormTextColor, White} from "../../Constants/ColorChart";
import styled from "styled-components";

const StyledTextarea = styled.textarea`
  border: none;
  width: 100%;
  font-size: 15pt;
  background: ${props => props.background ? props.background : White}
  color: ${props => props.color ? props.color : White};
  display: inline-block;
  padding: 2%;
  margin-right: 0;
  ${props => props.extraStyle && props.extraStyle};
  &::placeholder {
    color: ${props => props.color ? props.color : White};
  }
  &:focus {
    outline: none;
  }
`;

type LoginReasonsProps = {
    reason: string;
    handleChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    handleKeyPress: (event: KeyboardEvent<HTMLInputElement>) => void;
};

const LoginReasons: React.FC<LoginReasonsProps> = ({ reason, handleChange, handleKeyPress }) => {
  return (
      <div>
          <StyledTextarea
              placeholder="Escriba las razones por las cuales está accediendo."
              value={reason}
              onChange={handleChange}
              background={WerfenFormFieldColor}
              color={WerfenFormTextColor}
              extraStyle="padding-left: 50px;"
              rows={5}
              onKeyUp={handleKeyPress}
          />
      </div>
  );
};

export default LoginReasons;